import { defineStore } from 'pinia'
import { ref } from 'vue'

type Theme = 'light' | 'dark'

export const useThemeStore = defineStore('theme', () => {
  // Get initial theme from localStorage or system preference
  const getInitialTheme = (): Theme => {
    // Check localStorage
    const storedTheme = localStorage.getItem('theme') as Theme
    if (storedTheme === 'light' || storedTheme === 'dark') {
      return storedTheme
    }
    
    // Check system preference
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      return 'dark'
    }
    
    // Default to light theme
    return 'light'
  }

  // State
  const theme = ref<Theme>(getInitialTheme())
  
  // Apply theme to document when it changes
  const applyTheme = (newTheme: Theme) => {
    if (newTheme === 'dark') {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
    localStorage.setItem('theme', newTheme)
  }
  
  // Initialize theme on page load
  applyTheme(theme.value)
  
  // Actions
  const setTheme = (newTheme: Theme) => {
    theme.value = newTheme
    applyTheme(newTheme)
  }
  
  const toggleTheme = () => {
    setTheme(theme.value === 'light' ? 'dark' : 'light')
  }
  
  return {
    theme,
    setTheme,
    toggleTheme
  }
}) 